import React from 'react';
import Icon from './Icon';

const UploadIcon = (props) => (
    <Icon {...props}>
        <path
            d="M7 18H6C3.8 18 2 16.2 2 14C2 12 3.5 10.3 5.5 10.1C6 6.6 9 4 12.5 4C16.3 4 19.5 6.9 19.9 10.7C21.1 11.4 22 12.6 22 14C22 16.2 20.2 18 18 18H17M12 11V20M12 11L9 14M12 11L15 14"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default UploadIcon;
